import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const updateKycApi = createAsyncThunk(
  "updateKyc",
  async ({ id, startDate = null, endDate = null }) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.put(`/updateKyc/${id}`, { params });
    return response.data;
  }
);

const updateKycSlice = createSlice({
  name: "updateKyc",
  initialState: {
    updateKyc: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateKycApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateKycApi.fulfilled, (state, action) => {
        state.updateKyc = action.payload;
        state.loading = false;
      })
      .addCase(updateKycApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default updateKycSlice.reducer;
